module.exports = __webpack_public_path__ + "132932c0d0d3f076f43290d1753fa644.png";